/**
 * Skio Plan Picker - Buyer Consent Toggle
 * Hides buyer consent for one-time purchases, shows for subscriptions
 */

(function() {
  const SELECTORS = {
    SKIO_PICKER: 'skio-plan-picker',
    BUYER_CONSENT: 'shopify-buyer-consent',
    RADIO_PREFIX: 'skio-group-',
    ONE_TIME_PREFIX: 'one-time-'
  };

  let isListenerAttached = false;

  /**
   * Toggle buyer consent visibility based on purchase type
   */
  function toggleBuyerConsent(buyerConsent, isOneTime) {
    if (isOneTime) {
      buyerConsent.style.display = 'none';
    } else {
      buyerConsent.style.removeProperty('display');
    }
  }

  /**
   * Set initial buyer consent state based on selected radio button
   */
  function setInitialState(shadowRoot, buyerConsent) {
    const checkedRadio = shadowRoot.querySelector(
      `input[type="radio"][name^="${SELECTORS.RADIO_PREFIX}"]:checked`
    );

    if (checkedRadio) {
      const isOneTime = checkedRadio.id.startsWith(SELECTORS.ONE_TIME_PREFIX);
      toggleBuyerConsent(buyerConsent, isOneTime);
    }
  }

  /**
   * Handle radio button click
   */
  function handleRadioClick(event, buyerConsent) {
    const target = event.target;

    if (target.type !== 'radio' || !target.name?.startsWith(SELECTORS.RADIO_PREFIX)) {
      return;
    }

    const isOneTime = target.id.startsWith(SELECTORS.ONE_TIME_PREFIX);
    toggleBuyerConsent(buyerConsent, isOneTime);
  }

  /**
   * Attach event listener to shadow root
   */
  function attachEventListeners(shadowRoot, buyerConsent) {
    setInitialState(shadowRoot, buyerConsent);

    shadowRoot.addEventListener('click', (event) => handleRadioClick(event, buyerConsent));
  }

  /**
   * Wait for both Skio shadow root and buyer consent element to be ready
   */
  function waitForElements() {
    if (isListenerAttached) return;

    const skioPlanPicker = document.querySelector(SELECTORS.SKIO_PICKER);
    const buyerConsent = document.getElementById(SELECTORS.BUYER_CONSENT);

    attachEventListeners(skioPlanPicker.shadowRoot, buyerConsent);
    isListenerAttached = true;

  }

  /**
   * Initialize - wait for custom element to be defined
   */
  async function init() {
    await customElements.whenDefined(SELECTORS.SKIO_PICKER);
    waitForElements();
  }

  init();
})();
